"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressHelper = void 0;
const constants_1 = require("./constants");
class ProgressHelper {
    static async startScaffoldProgressHandler(ui, isAdd = false) {
        var _a;
        this.scaffoldProgress = ui === null || ui === void 0 ? void 0 : ui.createProgressBar(isAdd ? constants_1.ProgressTitleMessage.AddProgressTitle : constants_1.ProgressTitleMessage.ScaffoldProgressTitle, Object.entries(constants_1.ScaffoldProgressMessage).length);
        await ((_a = this.scaffoldProgress) === null || _a === void 0 ? void 0 : _a.start(""));
        return this.scaffoldProgress;
    }
    static async endScaffoldProgress(success) {
        var _a;
        await ((_a = this.scaffoldProgress) === null || _a === void 0 ? void 0 : _a.end(success));
        this.scaffoldProgress = undefined;
    }
}
exports.ProgressHelper = ProgressHelper;
//# sourceMappingURL=progress-helper.js.map